import { SymbolTypes } from '@/config/constants';
import { symbolsApi } from '@/api';

const symbolSearchFilters = [
  {
    name: 'groupingId',
    label: 'grouping',
    type: 'text',
    whereOperator: '=',
  },
  {
    name: 'labSampleCode',
    label: 'sampleId',
    type: 'text',
    whereOperator: 'regexp',
  },
  {
    name: 'analysisCode',
    label: 'analysisId',
    type: 'text',
    whereOperator: 'regexp',
  },
  {
    name: 'analysisDescription',
    label: 'analysisDescriptionFull',
    type: 'text',
    whereOperator: 'regexp',
  },
  {
    name: 'sequence',
    label: 'sequence',
    type: 'number',
    whereOperator: '=',
  },
  {
    name: 'operation',
    label: 'operation',
    type: 'text',
    whereOperator: 'regexp',
  },
  {
    name: 'symbolType',
    label: 'symbolType',
    type: 'select',
    whereOperator: '=',
    options: Object.values(SymbolTypes).map((val) => ({
      value: val,
      label: `enums.symbolTypes.${val}`,
    })),
  },
  {
    name: 'symbol',
    label: 'symbol',
    type: 'autocomplete',
    whereOperator: '=',
    autocompleteSearch: async (queryString, cb) => {
      const response = await symbolsApi.autocompleteFetch(queryString);
      const symbols = response.data.map((item) => ({
        label: item.name,
        value: item.name,
      }));
      cb(symbols);
    },
  },
  {
    name: 'symbolLot',
    label: 'lot',
    type: 'text',
    whereOperator: 'regexp',
  },
];

export default symbolSearchFilters;
